import {
  Box,
  Card,
  CardContent,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import { Fragment, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { bookSelectors, fetchBookAsync } from "./catalogSlice";
import placeholderSrc from "../../images/loading.gif";
import ProgressiveImg from "../../app/components/ProgressiveImg";
import NotFound from "../../app/errors/NotFound";
import LoadingComponent from "../../app/layout/LoadingComponent";
import BookOnlineRetailerListings from "./BookOnlineRetailerListings";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const BookDetails = () => {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const book = useAppSelector((state) =>
    bookSelectors.selectById(state, parseInt(id!))
  );
  const { status: bookStatus } = useAppSelector((state) => state.catalog);

  useEffect(() => {
    if (!book) {
      dispatch(fetchBookAsync(parseInt(id!)));
    }
  }, [id, book, dispatch]);

  if (bookStatus === "pendingFetchBook")
    return <Box sx={{height: 500}}><LoadingComponent message='Loading books...' /></Box>

  if (!book) return <NotFound />;

  const primaryAuthor = book.contributors.find(
    (contributor) => contributor.role === "Primary Author"
  );


  return (
    <Grid container spacing={2} sx={{ mt: 10, mb: 5 }}>

      <Grid size={{ xs: 12, sm: 3 }} >
        <Grid>
          <Link to={`/`} style={{ textDecoration: 'none', color: 'black' }}>
            <ArrowBackIosIcon fontSize="small" />
          </Link>
        </Grid>
        <ProgressiveImg
          src={book.coverDisplayLink}
          placeholderSrc={placeholderSrc}
          width="100%"
          height="auto"
        />
      </Grid>

      <Grid size={{ xs: 12, sm: 9 }} sx={{ mt: 8, }}>
        <Grid size={{ xs: 12}}>
          <Typography variant="h4" sx={{ color: '#369aac' }}>{book.title}</Typography>
          {book.subTitle !== "" && (
            <Typography variant="body1">{book.subTitle}</Typography>
          )}
          {primaryAuthor !== undefined && (
            <Typography variant="body2">by {primaryAuthor.name}</Typography>
          )}
        </Grid>
        <Grid container spacing={2} sx={{ mt: 1, }}>
          <Grid size={{ xs: 12, sm: 8 }}>
            <Typography variant="body2" sx={{ textAlign: 'justify' }}>{book.description}</Typography>
            <Card sx={{ mt: 4 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ flex: '1 0 auto' }}>
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        {book.contributors.map(
                          (contributor) =>
                            contributor.role !== "Primary Author" && (
                              <TableRow
                                key={`${contributor.role}${contributor.name}`}
                              >
                                <TableCell sx={{ verticalAlign: "top" }}>
                                  {contributor.role}
                                </TableCell>
                                <TableCell>{contributor.name}</TableCell>
                              </TableRow>
                            )
                        )}

                        {book.genre !== "<Not Selected>" && (
                          <TableRow>
                            <TableCell sx={{ verticalAlign: "top" }}>Genre </TableCell>
                            <TableCell>{book.genre}</TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell sx={{ verticalAlign: "top" }}>
                            Editions
                          </TableCell>
                          <TableCell>
                            {book.editions.map((edition) => (

                              <Fragment key={edition.isbn}>
                                {edition.bookFormat} Edition
                                <br />
                             <ul style={{ margin: 0 }}><li>ISBN: {edition.isbn}</li></ul>
                                {(edition.bookFormat === "Paperback" ||
                                  edition.bookFormat === "Hardcover") && (
                                    <ul style={{ margin: 0 }}>
                                      <li>Trim Size: {edition.bookDimensions.replace(/(.d*?)0+("|\))/g, '$1$2').replace(/\." /g, '" ')}</li> 
                                    </ul>
                                  )}
                              </Fragment>
                            ))}
                          </TableCell>
                        </TableRow>
                        {book.editions.map((edition, index) => (
                          <Fragment key={edition.pageCount}>

                            {index === 0 && (
                              edition.pageCount !== null && (
                                <TableRow>
                                  <TableCell sx={{ verticalAlign: "top" }}>
                                    Page Count
                                  </TableCell>
                                  <TableCell>
                                    <>
                                      {edition.pageCount} pages
                                    </>

                                  </TableCell>
                                </TableRow>
                              )
                            )}
                          </Fragment>

                        ))}
                    
                        <TableRow>
                          <TableCell sx={{ verticalAlign: "top" }}>
                          Publication Date
                          </TableCell>
                          <TableCell>{book.yearOfPublication}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ verticalAlign: "top", borderBottom: 'none' }}>Country</TableCell>
                          <TableCell sx={{borderBottom: 'none'}}>{book.country}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Box>
            </Card>
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <Box
              sx={{
                display: 'grid',
                justifyContent: 'center',
              }}
            >
              <BookOnlineRetailerListings book={book} />
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BookDetails;
